"use client";

import { useEffect, useState } from "react";
import axios from "axios";

// Tipe untuk data pengguna yang terkait dengan berita
interface User {
  id: number;
  name: string;
  email: string;
  about: string;
  image: string;
}

// Tipe untuk kategori yang terkait dengan subkategori
interface Category {
  id: number;
  name: string;
  slug: string;
  image: string;
  created_at: string;
  updated_at: string;
}

// Tipe untuk subkategori
interface SubCategory {
  id: number;
  name: string;
  slug: string;
  category: Category;
}

// Tipe untuk data berita
interface NewsData {
  id: number;
  title: string;
  slug: string;
  keyword: string;
  description: string;
  image: string;
  content: string;
  created_at: string;
  updated_at: string;
  user: User;
  sub_category: SubCategory;
}

// Tipe untuk respons API
interface ApiResponse {
  status: number;
  message: string;
  data: NewsData[];
}

export const useFetchNewsData = (slug?: string) => {
  const [newsData, setNewsData] = useState<ApiResponse | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = slug
          ? `https://admin.macspace.id/public/api/posts/${slug}`
          : "https://admin.macspace.id/public/api/posts";
        const response = await axios.get<ApiResponse>(url);
        setNewsData(response.data);
        console.log(newsData);
      } catch (error) {
        console.log(error);
        setNewsData(null);
      }
    };
    fetchData();
  }, [slug]);

  return newsData;
};
